import React from "react";
import { Route, Routes } from "react-router-dom";

import { AddDocumentBillPage } from "./add-document-bill/page";
import { ADD_DOCUMENT_BILL_PAGE } from "./consts";

export const DocumentUploadRouter = () => (
  <Routes>
    <Route
      path={ADD_DOCUMENT_BILL_PAGE.PATH}
      element={<AddDocumentBillPage />}
    />
  </Routes>
);
